module.exports = __webpack_public_path__ + "img/image2vector.eae76afa.svg";